// Fila de alertas da order. Cada card segue a anatomia: o que aconteceu
// (message) / o que fazer (action) / como detectamos (evidence, colapsado).
// As regras vêm prontas do motor — aqui é só apresentação.
import Badge from '../ui/Badge';

const SEV = {
    critical: { variant: 'danger', label: 'CRÍTICO', border: 'border-red-300 dark:border-red-800' },
    warn: { variant: 'warning', label: 'ATENÇÃO', border: 'border-yellow-300 dark:border-yellow-800' },
    info: { variant: 'info', label: 'INFO', border: 'border-blue-200 dark:border-blue-900' },
};
const ORDER = { critical: 0, warn: 1, info: 2 };

export default function AlertsSection({ rules }) {
    const visible = (rules || []).filter((r) => SEV[r.severity]).sort((a, b) => ORDER[a.severity] - ORDER[b.severity]);
    if (visible.length === 0) {
        return null;
    }
    return (
        <div id="alertas" className="space-y-2">
            <h2 className="text-lg font-bold">Alertas e divergências ({visible.length})</h2>
            {visible.map((r) => {
                const sev = SEV[r.severity];
                return (
                    <div key={`${r.id}-${r.title}`} className={`rounded-xl border-2 bg-white p-3 dark:bg-mono-900 ${sev.border}`}>
                        <div className="mb-1 flex flex-wrap items-center gap-2">
                            <Badge variant={sev.variant}>{sev.label}</Badge>
                            <span className="font-semibold">{r.title}</span>
                            <span className="ml-auto font-mono text-[10px] text-mono-400" title="id da regra no motor">
                                {r.id}
                            </span>
                        </div>
                        <p className="text-sm text-mono-600 dark:text-mono-300">{r.message}</p>
                        {r.action ? (
                            <p className="mt-1 text-sm">
                                <span className="font-semibold">O que fazer:</span> {r.action}
                            </p>
                        ) : null}
                        {r.evidence && Object.keys(r.evidence).length > 0 ? (
                            <details className="mt-1">
                                <summary className="cursor-pointer text-xs text-mono-400">como detectamos</summary>
                                <pre className="mt-1 overflow-x-auto rounded bg-mono-50 p-2 font-mono text-xs text-mono-500 dark:bg-mono-800">
                                    {JSON.stringify(r.evidence, null, 2)}
                                </pre>
                            </details>
                        ) : null}
                    </div>
                );
            })}
        </div>
    );
}
